<template>
	<a-table
		:columns="columns"
		:row-key="record => record.id"
		:data-source="getAccountList"
		:pagination="pagination"
		:loading="loading"
	>
		<div
			slot="filterDropdown"
			slot-scope="{
				setSelectedKeys,
				selectedKeys,
				confirm,
				clearFilters,
				column,
			}"
			style="padding: 8px"
		>
			<a-input
				v-ant-ref="c => (searchInput = c)"
				:placeholder="`Search Account`"
				:value="selectedKeys[0]"
				style="width: 188px; margin-bottom: 8px; display: block;"
				@change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
				@pressEnter="
					() => handleSearch(selectedKeys, confirm, column.dataIndex)
				"
			/>
			<a-button
				type="primary"
				icon="search"
				size="small"
				style="width: 90px; margin-right: 8px"
				@click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
			>
				Search
			</a-button>
			<a-button
				size="small"
				style="width: 90px"
				@click="() => handleReset(clearFilters)"
			>
				Reset
			</a-button>
		</div>

		<template slot="customRender" slot-scope="text, record, index, column">
			<span v-if="searchText && searchedColumn === column.dataIndex">
				<template
					v-for="(fragment, i) in text
						.toString()
						.split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
				>
					<mark
						v-if="fragment.toLowerCase() === searchText.toLowerCase()"
						:key="i"
						class="highlight"
						>{{ fragment }}</mark
					>
					<template v-else>{{ fragment }}</template>
				</template>
				<div class="text-gray-5">
					{{ record.typeName }}
				</div>
			</span>
			<template v-else>
				{{ text }}
				<div class="text-gray-5">
					{{ record.typeName }}
				</div>
			</template>
		</template>

		<a-icon
			slot="filterIcon"
			slot-scope="filtered"
			type="search"
			:style="{ color: filtered ? '#108ee9' : undefined }"
		/>

		<template slot="icon" slot-scope="record">
			<div class="text-center">
				<a-icon v-if="record.typeId === 1" type="user" />
				<a-icon v-if="record.typeId !== 1" type="home" />
			</div>
		</template>
		<template slot="account" slot-scope="record">
			{{ record.name }}
			<div class="text-gray-5">
				{{ record.typeName }}
			</div>
		</template>
		<template slot="network" slot-scope="record">
			<!-- <app-image
				:key="key"
				v-if="network === 'Instagram'"
				src="/resources/images/instagram-logo.png"
				style="position: absolute; top: 10px; right: 10px;width:23px;"
			/>
			<app-image
				:key="key"
				v-if="network === 'YouTube'"
				src="/resources/images/youtube-logo.png"
				style="position: absolute; top: 10px; right: 10px;width:23px;"
			/>
			<app-image
				:key="key"
				v-if="network === 'TikTok'"
				src="/resources/images/tiktok-logo.png"
				style="position: absolute; top: 10px; right: 10px;width:23px;"
			/> -->
			<div
				class="text-nowrap"
				v-for="(e, key) in record.networks.split(',')"
				:key="key"
			>
				<img
					:key="key"
					style="width:18px;"
					v-if="e === 'TikTok'"
					src="/resources/images/tiktok-logo.png"
				/>
				<img
					:key="key"
					v-if="e === 'Instagram'"
					src="/resources/images/instagram-logo.png"
					style="width:18px;"
				/>
				<img
					:key="key"
					v-if="e === 'Youtube'"
					src="/resources/images/youtube-logo.png"
					style="width:18px;"
				/>
			</div>
		</template>
		<template slot="post" slot-scope="record">
			{{ record.totalPosts.toLocaleString() }}
		</template>
		<template slot="followers" slot-scope="record">
			{{ record.totalFollowers.toLocaleString() }}
		</template>
		<template slot="actions" slot-scope="record">
			<div class="ml-auto">
				<a @click="onDeleteAccount(record)" class="text-danger">
					Delete
				</a>
				<a-divider type="vertical" />
				<router-link :to="'/account/' + record.id + '/profiles'">
					View
				</router-link>
			</div>
		</template>

		<template slot="group" slot-scope="text, record">
			<a-select
				:value="
					!isNaN(record.groupId) && record.groupId ? record.groupId : 'null'
				"
				@change="handleGroupChange($event, record)"
				style="width: 100%;"
			>
				<a-select-option value="null">
					Please select...
				</a-select-option>
				<a-select-option
					:value="group.id"
					v-for="(group, index) in getAccountGroups"
					:key="index"
				>
					{{ group.name }}
				</a-select-option>
			</a-select>
		</template>

		<div
			slot="groupfilterDropdown"
			slot-scope="{ setSelectedKeys, confirm, clearFilters, column }"
			style="padding: 8px"
		>
			<div class="d-flex flex-column justify-content-end">
				<a-select
					v-ant-ref="x => (searchGroup = x)"
					class=" mr-1"
					style="width: 188px; margin-bottom: 8px; display: block;"
					v-model="selectedGroup"
					@change="
						e => {
							return handleGroupSearch(
								e ? [e] : [],
								confirm,
								column.dataIndex,
								setSelectedKeys,
								clearFilters,
							)
						}
					"
				>
					<a-select-option value="none">
						Select...
					</a-select-option>
					<a-select-option
						:value="group.id"
						v-for="(group, index) in getAccountGroups"
						:key="index"
					>
						{{ group.name }}
					</a-select-option>
				</a-select>

				<a-button
					style="width: 90px"
					size="small"
					@click="() => handleReset(clearFilters)"
				>
					Reset
				</a-button>
			</div>
		</div>

		<a-icon
			slot="groupfilterIcon"
			slot-scope="filtered"
			type="search"
			:style="{ color: filtered ? '#108ee9' : undefined }"
		/>
	</a-table>
</template>

<script>
import * as ACTIONS from '@/store/actions'
import { mapGetters, mapActions } from 'vuex'

export default {
	name: 'AccountTableList',

	data: function() {
		return {
			accountData: [],
			pagination: {},
			loading: false,
			columns: [
				{
					title: '',
					scopedSlots: { customRender: 'icon' },
				},

				{
					title: 'Account',
					dataIndex: 'name',
					scopedSlots: {
						customRender: 'customRender',
						filterDropdown: 'filterDropdown',
						filterIcon: 'filterIcon',
					},
					sorter: (a, b) => a.name.localeCompare(b.name),
					onFilter: (value, record) => {
						return record.name
							.toString()
							.toLowerCase()
							.includes(value.toLowerCase())
					},

					onFilterDropdownVisibleChange: visible => {
						if (visible) {
							setTimeout(() => {
								this.searchInput.focus()
							}, 0)
						}
					},
				},
				{
					title: 'Network',
					scopedSlots: { customRender: 'network' },
				},
				{
					title: 'Post',
					scopedSlots: { customRender: 'post' },
					sorter: (a, b) => a.totalPosts - b.totalPosts,
				},
				{
					title: 'Followers',
					scopedSlots: { customRender: 'followers' },
					sorter: (a, b) => a.totalFollowers - b.totalFollowers,
				},
				{
					title: 'Group',
					dataIndex: 'groupId',
					width: 250,
					scopedSlots: {
						customRender: 'group',
						filterDropdown: 'groupfilterDropdown',
						filterIcon: 'groupfilterIcon',
					},
					onFilter: (value, record) => {
						return record.groupId === value
					},

					onFilterDropdownVisibleChange: visible => {
						if (visible) {
							setTimeout(() => {
								this.searchGroup.focus()
							}, 0)
						}
					},
				},

				{
					title: 'Actions',
					align: 'center',
					scopedSlots: { customRender: 'actions' },
				},
			],
			searchText: null,
			searchedColumn: null,
			searchInput: null,
			searchGroup: null,
			selectedGroup: 'none',
		}
	},
	created() {
		this.loading = true
		this.loadAccountList().then(res => {
			console.log(res)
			this.accountData = res
			this.loading = false
		})

		this.loadAccountGroup()
	},

	methods: {
		handleGroupSearch(key, confirm, dataIndex, setSelectedKeys, clearFilters) {
			if (key[0] === 'none') {
				clearFilters()
			} else {
				setSelectedKeys(key)
				confirm()
				this.searchText = key[0]
				this.searchedColumn = dataIndex
			}
		},

		handleSearch(selectedKeys, confirm, dataIndex) {
			confirm()
			this.searchText = selectedKeys[0]
			this.searchedColumn = dataIndex
		},

		handleReset(clearFilters) {
			clearFilters()
			this.searchText = ''
			this.selectedGroup = 'none'
		},

		handleGroupChange(event, account) {
			let groupId = account

			if (isNaN(event)) {
				groupId = null
			} else {
				groupId = event
			}
			this.accountData.map(element => {
				if (element.groupId === groupId) {
					const tagId = element.tagId
					this.updateAccount({ groupId, tagId }).then(res => {
						this.$notification.success('Account updated')
					})
				}
			})
		},

		networkOcurrence(networks) {
			console.log(networks)
			if (networks) {
				const a = networks.split(',').reduce((acc, c) => {
					acc[c] = (acc[c] || 0) + 1
					return acc
				}, {})

				return a
			} else {
				return []
			}
		},
		onDeleteAccount(influencer) {
			this.$confirm({
				title: 'Delete the following Account?',
				content: influencer.name,
				okText: 'Yes',
				okType: 'success',
				cancelText: 'No',
				onOk: () => {
					this.deleteAccount({ influencer })
				},
			})
		},
		...mapActions({
			loadAccountList: ACTIONS.ACCOUNT.LIST,
			deleteAccount: ACTIONS.ACCOUNT.DELETE,
			loadAccountGroup: ACTIONS.ACCOUNT_GROUP.LIST,
			updateAccount: ACTIONS.ACCOUNT.UPDATE,
		}),
	},
	computed: {
		...mapGetters(['getAccountList', 'getAccountGroups']),
	},
}
</script>

<style></style>
